<craft-text-toolbar position="static" class="toolbar" [state]="isFocused"></craft-text-toolbar>
<div
  class="text-editor"
  contenteditable="true"
  [attr.placeholder]="placeholder"
  #textEditor
  (paste)="onPaste($event)"
  (input)="onInput()"
  (focus)="onFocus()"
  (blur)="onBlur()"
></div>
